// extracted by mini-css-extract-plugin
export var icon = "notice-module--icon--e3d52";
export var icon_wrap = "notice-module--icon_wrap--9dd75";
export var message = "notice-module--message--b3f6a";
export var message_wrap = "notice-module--message_wrap--1e8e6";
export var notice = "notice-module--notice--bb043";